import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
// import { reducer } from '../reducer/Reducer';
import rootReducer from './reducers/rootReducer';

const middlewares: any[] = [thunk];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

export const ReduxStore = createStore(
  rootReducer,
  applyMiddleware(...middlewares)
);



// WEBPACK FOOTER //
// ./src/redux/store.ts